import {
	CurrentlySelectedFilePath,
	RemoveFromCurrentlySelectedFilePath,
} from "../../state/files";
import { useRecoilCallback, useRecoilValue } from "recoil";

import { File } from "./File";
import type { FileTreeType } from "./groupByFolder";
import { Folder } from "./Folder";
import { Fragment } from "react";
import { SortStoriesBy } from "../../state/uiAtoms";
import { sortBy } from "lodash-es";

const Level = ({ fileTree }: { fileTree: FileTreeType }) => {
	const level = useRecoilValue(CurrentlySelectedFilePath);
	const sortStoriesBy = useRecoilValue(SortStoriesBy);
	const removeLevel = useRecoilCallback(({ set }) => () => {
		if (level) {
			set(RemoveFromCurrentlySelectedFilePath, level[level.length - 1]);
		}
	});
	if (!level) return <></>;

	if (Object.keys(fileTree).length === 0) return <></>; // empty fileTree

	const currentLevel = level.reduce<FileTreeType | FileTreeType[string]>(
		(branch, fileName) => {
			// @ts-expect-error: typing dynamic objects? I give up
			return branch[fileName];
		},
		fileTree as FileTreeType,
	);

	if (!currentLevel && level.length > 1) {
		removeLevel();
		return <></>;
	}

	let currentLevelArray = Object.entries(currentLevel);

	currentLevelArray = sortBy(currentLevelArray, (obj) => obj[1][sortStoriesBy]);

	const fileJsx = currentLevelArray.map((entry) => {
		const fileName = entry[0];
		const keyName = `${level}-${fileName}-file`;
		// @ts-expect-error: typing dynamic objects? I give up
		if (currentLevel[fileName].isFile) {
			// @ts-expect-error: typing dynamic objects? I give up
			const stackCfKey = currentLevel[fileName].stackCfKey;
			// @ts-expect-error: typing dynamic objects? I give up
			const updated = currentLevel[fileName].updatedString;
			// @ts-expect-error: typing dynamic objects? I give up
			const created = currentLevel[fileName].createdString;

			return (
				<File
					key={keyName}
					stackFileName={fileName}
					stackCfKey={stackCfKey}
					updated={updated}
					created={created}
				/>
			);
		}
		return <Fragment key={`empty-${keyName}`} />;
	});

	const folderJsx = currentLevelArray.map((entry) => {
		const folderName = entry[0];
		const keyName = `${level}-${folderName}-folder`;
		// @ts-expect-error: sigh
		if (currentLevel[folderName].isFolder) {
			return <Folder key={keyName} folderName={folderName} />;
		}
		return <Fragment key={`empty-${keyName}`} />;
	});

	return <>{[folderJsx, ...fileJsx]}</>;
};

export default Level;
